module.exports = __webpack_public_path__ + "static/media/image5.6d09fb55.png";